var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendario"},[_c('BotaoPadrao',{staticClass:"botao-cenario",attrs:{"arredondadoEsquerda":"","nome":"Calendário de Obrigações","icone":"calendar-alt","click":_vm.abreCalendario}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }